/**
 * Created by joe on 16/9/6.
 */

module.exports = require('./lib/DragScroll');



//////////////////
// WEBPACK FOOTER
// ./~/react-dragscroll/index.js
// module id = 617
// module chunks = 153662236231701